import { useQuery } from "@tanstack/react-query";
import { getInvoiceByExternalUid } from "../actions/get-invoice-by-external-uid.action";
import { INVOICES_KEY } from "../query/invoices.queries";

export const useInvoiceByExternalUidQuery = (externalUid?: string, enabled = true) => {
  return useQuery({
    queryKey: [...INVOICES_KEY, "by-external-uid", externalUid],
    queryFn: () => getInvoiceByExternalUid({ externalUid: externalUid! }),
    enabled: Boolean(externalUid) && enabled,
    staleTime: 30_000,
    retry: 1,
  });
};
